import { render, staticRenderFns } from "./VariationCard.vue?vue&type=template&id=86578dc8&scoped=true&"
import script from "./VariationCard.vue?vue&type=script&lang=js&"
export * from "./VariationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86578dc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86578dc8')) {
      api.createRecord('86578dc8', component.options)
    } else {
      api.reload('86578dc8', component.options)
    }
    module.hot.accept("./VariationCard.vue?vue&type=template&id=86578dc8&scoped=true&", function () {
      api.rerender('86578dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/options/showcase/tvpackage/component/VariationCard.vue"
export default component.exports